module.exports = __webpack_public_path__ + "static/productphotographysofiamoraes-63f64e96db2c488d76b6e06eb4922616.jpeg";